import { render, staticRenderFns } from "./EditActionWorkspace.vue?vue&type=template&id=60e3ad11"
import script from "./EditActionWorkspace.vue?vue&type=script&lang=js"
export * from "./EditActionWorkspace.vue?vue&type=script&lang=js"
import style0 from "./EditActionWorkspace.vue?vue&type=style&index=0&id=60e3ad11&prod&defer=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports